<template>
  <div class="">
    <el-form class="form-inline" :inline="true">
      <el-form-item label="">
        <el-input v-model="wechat" placeholder="请输入微信号" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="bandWechat()">绑定体验者</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        ref="rfTable"
        border
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="appid"
          label="appid"
          align="center">
      </el-table-column>
      <el-table-column
          prop="name"
          label="微信号"
          align="center">
      </el-table-column>
      <el-table-column
          prop="ftime"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-popconfirm
              title="确定解绑吗？"
              @confirm="unBandWechat(scope.row)"
          >
            <el-button slot="reference" type="text" size="small">解绑</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        wechat: '',
        search: {
          current_page: 1,
          total: 0,
          limit: 10,
          keywords: ''
        },
        tableData: []
      }
    },
    components: {
    },
    props: {
      id: Number
    },
    created() {
      this.getList()
    },
    mounted() {
    },
    methods: {
      bandWechat() {
        if(this.wechat == '') {
          this.fail('请填写微信号')
          return false
        }
        this.$api.wechat.wechatTestBand({id:this.id,wechat:this.wechat}, res => {
          if(res.errcode==0) {
            this.wechat = ''
            this.success(res.errmsg)
            this.getList()
          } else {
            this.fail(res.errmsg)
          }
        })
      },
      unBandWechat(item) {
        this.$api.wechat.wechatTestUnBand({id:item.id}, res => {
          if(res.errcode==0) {
            this.success(res.errmsg)
            this.getList()
          } else {
            this.fail(res.errmsg)
          }
        })
      },
      getList() {
        var that = this
        that.showLoading()
        var param = {
          page: that.search.current_page,
          page_size: that.search.limit,
          id: that.id
        }
        this.$api.wechat.wechatTestIndex(param, function (res) {
          that.hideLoading()
          if(res.errcode == 0) {
            that.tableData = res.data.data
            that.search.current_page = res.data.current_page
            that.search.total = res.data.total
          } else {
            that.fail(res.errmsg)
          }
        })
      },
      handleSearch() {
        this.search.current_page = 1
        this.getList()
      },
      handleSelectionChange(rows) {
      },
      handleCurrentChange(val) {
        this.search.current_page = val
        this.getList()
      },
      handleSizeChange(val) {
        this.search.current_page = 1
        this.search.limit = val
        this.getList()
      }
    }
  }
</script>

<style scoped>
</style>
